/**
 * Página de contato (`/contato`). Texto puro: a tela e o teste leem daqui.
 * E-mail, horário, prazo e redes vêm de `COMPANY` (`content/facts.ts`).
 */
import { COMPANY } from '../facts';

export const CONTACT_PATH = '/contato';
export const CONTACT_TITLE = 'Fale com a Controlapag';
export const CONTACT_DESCRIPTION =
  `Contato da Controlapag: e-mail ${COMPANY.email}, ${COMPANY.supportHours}, resposta em ${COMPANY.supportResponse}. Veja o que mandar em cada assunto.`;

export const CONTACT_ANSWER = `O contato da Controlapag é o e-mail ${COMPANY.email}. Respondemos ${COMPANY.supportHours} (horário de Brasília), em ${COMPANY.supportResponse}. A empresa fica em ${COMPANY.city}/${COMPANY.region}.`;

export interface ContactSubject {
  id: string;
  title: string;
  /** Quando escrever sobre isso. */
  when: string;
  /** O que mandar no e-mail para a resposta sair de primeira. */
  send: string;
  /** Assunto sugerido do e-mail. */
  emailSubject: string;
}

export const CONTACT_SUBJECTS: ContactSubject[] = [
  {
    id: 'conta',
    title: 'Conta e acesso',
    when: 'Não consegue entrar, não recebeu o código no WhatsApp, quer trocar o e-mail ou o telefone da conta.',
    send: 'O e-mail ou o telefone da conta, se você é profissional ou cliente, e o que aparece na tela (um print ajuda).',
    emailSubject: 'Conta e acesso',
  },
  {
    id: 'assinatura',
    title: 'Assinatura e cobrança da Controlapag',
    when: 'Dúvida sobre o plano, cobrança do cartão, cancelamento ou desistência em até 7 dias.',
    send: 'O e-mail da conta, onde você assinou (site, App Store ou Google Play) e a data da cobrança. Assinatura feita na App Store ou no Google Play é cancelada na própria loja.',
    emailSubject: 'Assinatura',
  },
  {
    id: 'recebimento',
    title: 'Recebimento pelo link',
    when: 'Ativação do recebimento, pagamento de cliente que não deu baixa, repasse, reembolso ou contestação.',
    send: 'O e-mail da conta, o nome do cliente, o valor e a data da cobrança. Nunca mande senha, número completo de cartão ou dados bancários por e-mail.',
    emailSubject: 'Recebimento pelo link',
  },
  {
    id: 'privacidade',
    title: 'Privacidade, LGPD e exclusão de dados',
    when: 'Pedido de acesso, correção, portabilidade ou exclusão dos seus dados, ou dúvida sobre como tratamos dados.',
    send: 'Seu nome, o e-mail ou telefone ligado aos dados e o que você quer. Se você é cliente de um profissional, diga qual. Respondemos em até 15 dias.',
    emailSubject: 'Privacidade e LGPD',
  },
  {
    id: 'imprensa',
    title: 'Imprensa e parcerias',
    when: 'Entrevista, reportagem, parceria com associação, escola ou empresa do seu ramo.',
    send: 'Seu nome, o veículo ou a empresa, o assunto e o prazo.',
    emailSubject: 'Imprensa e parcerias',
  },
];

export const CONTACT_SOCIAL = [
  { label: 'Instagram', url: COMPANY.instagram },
  { label: 'Facebook', url: COMPANY.facebook },
  { label: 'LinkedIn', url: COMPANY.linkedin },
] as const;

export const mailtoFor = (subject: string): string =>
  `mailto:${COMPANY.email}?subject=${encodeURIComponent(subject)}`;
